import React, { useState, useEffect, useRef } from "react";
import TwilioVideo from "twilio-video";
import { Twilio } from "twilio";

const Video = ({ token, roomName, host, guest }) => {
  const [hostDevice, setHostDevice] = useState(false);
  const localVidRef = useRef();
  const remoteVidRef = useRef();
  useEffect(() => {
    if (roomName) {
      TwilioVideo.connect(token, {
        video: host ? true : false,
        audio: true,
        name: roomName,
      })
        .then((room) => {
          //Attach local video
          if (host) {
            console.log("HOST HAS JOINED WITH VIDEO");
            TwilioVideo.createLocalVideoTrack().then((track) => {
              localVidRef.current.appendChild(track.attach());
            });
            setHostDevice(true);
          } else {
            console.log("GUEST HAS JOINED WITH AUDIO");
            TwilioVideo.createLocalAudioTrack().then((track) => {
              localVidRef.current.appendChild(track.attach());
            });
          }

          console.log(`Successfully joined room: ${room}`);

          //Attach remote video for all participants
          room.on("participantConnected", participantConnected);
          room.participants.forEach(participantConnected);

          room.on("participantDisconnected", participantDisconnected);
          // room.localParticipant.tracks.forEach((track) => track.stop());
        })
        .catch((err) => {
          console.log("There's an error :" + err);
        });
    }
  }, [token]);

  function participantConnected(participant) {
    console.log('Participant "%s" connected', participant.identity);
    participant.tracks.forEach((publication) => {
      if (publication.isSubscribed) {
        const track = publication.track;
        remoteVidRef.current.appendChild(track.attach());
      }
    });

    participant.on("trackSubscribed", (track) => {
      remoteVidRef.current.appendChild(track.attach());
    });
    participant.on("trackUnsubscribed", (track) => {
      track.detach().forEach((element) => element.remove());
    });
  }

  function participantDisconnected(participant) {
    console.log('Participant "%s" disconnected', participant.identity);
  }

  return (
    <div>
      {!hostDevice ? (
        <span style={{ color: "white" }}>Video chat has not started</span>
      ) : null}
      <div ref={localVidRef}></div>
      <div ref={remoteVidRef}></div>
    </div>
  );
};

export default Video;
